/*
 * Kettlebell-Finder
 *
 * Liest Texte, Produktziele und Gewichtsspannen aus dem JSON-Block im Snippet.
 * Im Skript steht bewusst kein einziger sichtbarer String -- sonst waere er
 * nicht uebersetzbar. Dieselbe Regel wie bei ceq-turf-werkzeuge.js.
 *
 * Vier Antworten -> eine Empfehlung:
 *   ort        zuhause | box | praxis
 *   vorhaben   schwung | ueberkopf | wettkampf | reha
 *   erfahrung  anfang | regelmaessig | schwer
 *   platz      ecke | raum | flaeche
 */
(function () {
  'use strict';

  function empfehlung(a) {
    // Die Bauart kommt zuerst, weil sie am Vorhaben haengt -- ein Set ist der
    // Ausnahmefall, nicht der Normalfall. Gemessen an zwoelf Monaten
    // Bestellungen (629 mit Kettlebells): 54 % enthalten genau eine Kugel,
    // 82 % hoechstens zwei, und auf rund 1'100 einzeln verkaufte Kugeln kommen
    // 27 verkaufte Sets. Eine frueher zuerst gepruefte Set-Regel schickte
    // dagegen 56 % aller Antwortwege auf ein Set.
    var haupt;
    var alternative = null;
    var ueberKopf = a.vorhaben === 'ueberkopf' || a.vorhaben === 'wettkampf' || a.vorhaben === 'hyrox';

    var bauart;
    if (a.vorhaben === 'schwung' || a.vorhaben === 'reha') {
      bauart = 'gusseisen';
    } else if (a.vorhaben === 'wettkampf' || a.vorhaben === 'hyrox') {
      // HYROX: der Farmers Carry laeuft mit zwei gleichen Kugeln bis 32 kg -- das
      // deckt die Competition ab, und der Griff bleibt ueber alle Gewichte derselbe.
      bauart = 'competition';
    } else {
      // ueberkopf: ueber 32 kg endet die Stahl-Competition, dort uebernimmt Hollow.
      bauart = a.erfahrung === 'schwer' ? 'hollow' : 'competition';
    }

    // Ein Set bekommt, wer eine Flaeche ausstattet und das nicht zuhause tut --
    // also Box oder Praxis. Reha faellt raus: die Sets fangen bei 8 kg an,
    // darunter liegt die Arbeit, um die es dort geht.
    var stattetAus = a.platz === 'flaeche' && a.ort !== 'zuhause' && a.vorhaben !== 'reha';

    if (stattetAus) {
      // Paare nur in der Box -- dort stehen zwei Leute am selben Gewicht.
      if (a.ort === 'box') {
        haupt = ueberKopf ? 'set_comp_pro' : 'set_pc_pro';
      } else {
        haupt = ueberKopf ? 'set_comp_basic' : 'set_pc_basic';
      }
      alternative = bauart;
    } else {
      haupt = bauart;
      if (a.platz === 'flaeche' && a.vorhaben !== 'reha') {
        // Zuhause eine Flaeche ausstatten: eine Kugel bleibt die Empfehlung,
        // das Set steht daneben. Das Starter Set deckt 8-24 kg ab.
        if (ueberKopf) {
          alternative = 'set_comp_basic';
        } else {
          alternative = a.erfahrung === 'anfang' ? 'set_pc_starter' : 'set_pc_basic';
        }
      } else if (a.vorhaben === 'ueberkopf') {
        // Anfaenger ueber Kopf: der Richtwert beginnt bei 4 kg, die Competition erst
        // bei 8 kg -- darunter liegt die Small (4/6 kg).
        alternative = a.erfahrung === 'anfang' ? 'small' : 'eco_hollow';
      } else if (a.vorhaben === 'reha') {
        // Reha bleibt bei Gusseisen (deckt auch die Schwung-Richtwerte ab), die Small
        // steht daneben fuer Get Up und Halo in Competition-Form.
        alternative = 'small';
      } else if (a.vorhaben === 'hyrox') {
        // Fuer den Farmers Carry zaehlt das Gewicht, nicht die Bauart -- Gusseisen
        // tut es auch und kostet weniger.
        alternative = 'gusseisen';
      }
    }

    // Wenig Platz und zuhause: die verstellbare Kugel ersetzt ein halbes Regal.
    // Aber nicht fuer Anfaenger und nicht fuer Reha: Sie faengt erst bei 12 kg an,
    // und genau darunter liegen die Gewichte fuer Technik-, Ueberkopf- und
    // Rehaarbeit (gemessen an der Produktseite: 12-32 kg in 1-kg-Schritten).
    // Bei HYROX ebenfalls nicht: gebraucht wird ein Paar, nicht eine Kugel mit Scheiben.
    if (a.platz === 'ecke' && a.ort === 'zuhause' && haupt.indexOf('set_') !== 0
        && a.erfahrung !== 'anfang' && a.vorhaben !== 'reha' && a.vorhaben !== 'hyrox') {
      alternative = 'verstellbar';
    }

    return { haupt: haupt, alternative: alternative };
  }

  function hinweis(a, daten) {
    if (a.vorhaben === 'hyrox') return daten.hinweise.hyrox;
    if (a.vorhaben === 'reha') return daten.hinweise.reha;
    if (a.vorhaben === 'wettkampf') return daten.hinweise.wettkampf;
    if (a.ort === 'box') return daten.hinweise.box;
    if (a.platz === 'ecke') return daten.hinweise.ecke;
    return '';
  }

  function start(wurzel) {
    var datenTag = wurzel.querySelector('[data-kbf-daten]');
    if (!datenTag) return;

    var daten;
    try {
      daten = JSON.parse(datenTag.textContent);
    } catch (e) {
      return;
    }

    var antworten = {};
    var ergebnis = wurzel.querySelector('[data-kbf="ergebnis"]');
    var unvollstaendig = wurzel.querySelector('[data-kbf="unvollstaendig"]');
    var fragen = wurzel.querySelectorAll('[data-kbf-frage]');

    function feld(name) {
      return wurzel.querySelector('[data-kbf="' + name + '"]');
    }

    function zeichnen() {
      if (Object.keys(antworten).length < fragen.length) {
        ergebnis.hidden = true;
        if (unvollstaendig) unvollstaendig.hidden = false;
        return;
      }

      var wahl = empfehlung(antworten);
      var produkt = daten.produkte[wahl.haupt];
      var gewicht = daten.gewichte[antworten.erfahrung];

      feld('titel').textContent = produkt.titel;
      feld('begruendung').textContent = produkt.text;
      feld('gewicht_schwung').textContent = gewicht.schwung;
      feld('gewicht_ueberkopf').textContent = gewicht.ueberkopf;
      // Die Menge muss zur Empfehlung passen: "ein Set, mehrfach" darf nicht
      // neben einer einzelnen Kugel stehen, wenn jemand zuhause eine Flaeche
      // ausstattet -- dort ist die Flaeche kein Set-Fall mehr.
      var menge = antworten.platz;
      var brauchtPaar = antworten.vorhaben === 'hyrox' || antworten.vorhaben === 'wettkampf';
      if (brauchtPaar && wahl.haupt.indexOf('set_') !== 0) {
        // Farmers Carry wie Double Clean und Long Cycle brauchen zweimal dasselbe Gewicht --
        // das steht ueber der Platzfrage, sonst widerspricht die Menge dem Hinweis darunter.
        menge = 'paar';
      } else if (menge === 'flaeche' && wahl.haupt.indexOf('set_') !== 0) {
        menge = 'flaeche_einzeln';
      }
      feld('anzahl').textContent = daten.anzahl[menge];

      var haupt = feld('link_haupt');
      haupt.setAttribute('href', produkt.href);

      var alt = feld('link_alt');
      if (wahl.alternative && daten.produkte[wahl.alternative]) {
        var alternativ = daten.produkte[wahl.alternative];
        alt.setAttribute('href', alternativ.href);
        alt.textContent = daten.labels.alternative.replace('%s', alternativ.titel);
        alt.hidden = false;
      } else {
        alt.hidden = true;
      }

      var text = hinweis(antworten, daten);
      var hinweisFeld = feld('hinweis');
      hinweisFeld.textContent = text;
      hinweisFeld.hidden = !text;

      ergebnis.hidden = false;
      if (unvollstaendig) unvollstaendig.hidden = true;
    }

    // Die Auswahl ueberlebt den Weg zur Produktseite und zurueck. Ohne das war
    // der Finder nach "Zurueck" leer, und wer nur eine Antwort aendern wollte,
    // musste alle vier neu setzen. sessionStorage statt localStorage: die
    // Auswahl gilt fuer diesen Besuch, nicht fuer immer. Blockierter Speicher
    // (privates Fenster, gesperrte Cookies) laesst den Finder normal laufen.
    var speicherSchluessel = 'ceq-kbf:' + window.location.pathname;

    function speichern() {
      try {
        window.sessionStorage.setItem(speicherSchluessel, JSON.stringify(antworten));
      } catch (e) { /* ohne Speicher geht es auch */ }
    }

    function markieren(block, chip) {
      block.querySelectorAll('[data-kbf-opt]').forEach(function (anderer) {
        anderer.setAttribute('aria-pressed', 'false');
        anderer.classList.remove('is-aktiv');
      });
      chip.setAttribute('aria-pressed', 'true');
      chip.classList.add('is-aktiv');
    }

    function wiederherstellen() {
      var gespeichert = null;
      try {
        gespeichert = JSON.parse(window.sessionStorage.getItem(speicherSchluessel) || 'null');
      } catch (e) {
        return;
      }
      if (!gespeichert || typeof gespeichert !== 'object') return;

      fragen.forEach(function (block) {
        var name = block.getAttribute('data-kbf-frage');
        var wert = gespeichert[name];
        if (!wert) return;
        // Nur Werte uebernehmen, die es als Knopf noch gibt -- ein veralteter
        // Eintrag nach einer Aenderung am Finder wird still ignoriert.
        block.querySelectorAll('[data-kbf-opt]').forEach(function (chip) {
          if (chip.getAttribute('data-kbf-opt') === wert) {
            markieren(block, chip);
            antworten[name] = wert;
          }
        });
      });
      if (Object.keys(antworten).length) zeichnen();
    }

    fragen.forEach(function (block) {
      var name = block.getAttribute('data-kbf-frage');
      block.querySelectorAll('[data-kbf-opt]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          markieren(block, chip);
          antworten[name] = chip.getAttribute('data-kbf-opt');
          speichern();
          zeichnen();
        });
      });
    });

    wiederherstellen();
  }

  function init() {
    document.querySelectorAll('[data-ceq-kbf]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
